var DeviceUtil = /** @class */ (function () {
    function DeviceUtil() {
    }
    DeviceUtil.isMobile = function () {
        return /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || DeviceUtil.isIOS() || DeviceUtil.isMobileSize();
    };
    DeviceUtil.isMobileSize = function () {
        return window.innerWidth <= 500;
    };
    DeviceUtil.isIOS = function () {
        return /iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    };
    return DeviceUtil;
}());
export { DeviceUtil };
